import * as RadioGroupRadix from '@radix-ui/react-radio-group';
import { setTempRate } from 'features/cart/cartSlice';
import { openModal } from 'features/modalSlice';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

const RadioGroupCustom = ({
    setSelectedRate,
    items = [],
    selectedRate = 0,
}) => {
    const dispatch = useDispatch();
    const isAddingRate = useSelector((state) => state.cart?.isAddingRate);
    const onValueChange = (rateIndex) => {
        if (isAddingRate) {
            return;
        }
        if (!items[rateIndex].noClick) {
            setSelectedRate(items[rateIndex].id);
        } else {
            dispatch(
                setTempRate({
                    tempRate: items[rateIndex].id,
                    roomTypeID: items[rateIndex].room.roomTypeID,
                })
            );
            dispatch(
                openModal({
                    modalId: 'AreYouSureModal',
                })
            );
        }
    };

    // Find the index of the selectedRate in the items array
    const defaultIndex = items.findIndex((item) => item?.id === selectedRate);

    return (
        <div>
            <RadioGroupRadix.Root
                className="ab-RadioGroupRoot-Gen"
                value={defaultIndex !== -1 ? defaultIndex : 0}
            >
                {items.map((item, index) => (
                    <div
                        key={index}
                        className="ab-radio-wrapper"
                        onClick={() => onValueChange(index)}
                    >
                        <RadioGroupRadix.Item
                            className="ab-RadioGroupItem-Gen"
                            value={index}
                            id={item.id}
                            disabled={item?.noClick}
                        >
                            <RadioGroupRadix.Indicator className="ab-RadioGroupIndicator-Gen" />
                        </RadioGroupRadix.Item>
                        <label htmlFor={item.id}>
                            {typeof item.label === 'function' ? (
                                <item.label />
                            ) : (
                                item.label
                            )}
                        </label>
                    </div>
                ))}
            </RadioGroupRadix.Root>
        </div>
    );
};

RadioGroupCustom.propTypes = {
    setSelectedRate: PropTypes.func,
    items: PropTypes.array,
    selectedRate: PropTypes.number,
};

export default RadioGroupCustom;
